import { render, staticRenderFns } from "./CustomerWrapper.vue?vue&type=template&id=3c0855aa"
import script from "./CustomerWrapper.vue?vue&type=script&lang=js"
export * from "./CustomerWrapper.vue?vue&type=script&lang=js"
import style0 from "./CustomerWrapper.vue?vue&type=style&index=0&id=3c0855aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports